/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Program } from '../../models/program';

export interface UpdateAdminProgram$Params {
  id: string;
  body: Program;
}

export function updateAdminProgram(
  http: HttpClient,
  rootUrl: string,
  params: UpdateAdminProgram$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Program>> {
  const rb = new RequestBuilder(rootUrl, updateAdminProgram.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Program>;
    })
  );
}

updateAdminProgram.PATH = '/admin/programs/{id}';
